<div class="sample-nav">
  <div class="button-bar row">
    <div class="col-xs-offset-0">
      <a
        h3TrackAs
        [href]="samplingHomeHref$ | async"
        class="btn btn-default btn-sm"
        [eventId]="'exit_sampling_workspace'"
        [subBucket]="'page'"
      >
        Exit
      </a>
    </div>
    <div class="col-xs-11 text-center">
      <h3-sampling-workspace-nav
        [pagePosition]="pagePosition"
      ></h3-sampling-workspace-nav>
    </div>
  </div>

  <hr />

  <div class="row">
    <div class="col-xs-7">
      <strong>Agents:</strong>
      <h3-agents-per-step *ngIf="submitters$ | async"></h3-agents-per-step>
    </div>
  </div>
</div>
